import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService, LoggingService, UtilsJson, UtilsString } from '@pit/core';
import { EntityDataService } from '@pit/core-data';
import { DtoShipmentReturnCode, IDtoShipmentReturnCode } from '@pit/frontend-model';
import { IDtoShipmentReturnCodeEntityDataService } from '../interfaces/dto.shipment.return.code.entity.data.service.interface';

@Injectable({
  providedIn: 'root'
})
export class DtoShipmentReturnCodeEntityDataService extends EntityDataService<IDtoShipmentReturnCode> implements IDtoShipmentReturnCodeEntityDataService {

  constructor(http: HttpClient, configService: ConfigService, loggingService: LoggingService) {
    super(http, null, configService, loggingService);
  }

  protected override doGetApiUrl(): string {
    return UtilsString.stringFormat('/api/web/shipmentreturncodes');
  }

  protected override createEntityFromJson(json: any): IDtoShipmentReturnCode {
    const result: IDtoShipmentReturnCode = (UtilsJson.deserialize(json, DtoShipmentReturnCode) as IDtoShipmentReturnCode);
    if (result !== null) {
      result.setReferences();
    }

    return result;
  }

}
